import { functions } from "../firebase";
import {
  RevenueCatApp,
  RevenueCatConfig,
  RevenueCatSummary,
} from "../../types/RevenueCat";

// Read the integration state (whether a project id + secret are configured). The
// secret key itself is never returned by the callable.
export const getRevenueCatConfig = async (
  communityId: string
): Promise<RevenueCatConfig> => {
  const callable = functions.httpsCallable("getRevenueCatConfig");
  const result = await callable({ communityId });
  return (result.data || {}) as RevenueCatConfig;
};

// Save the community's RevenueCat project id + secret key. Omit secretApiKey to
// keep the previously stored one (e.g. when only changing currency or app). Pass
// appId "" to scope to the whole project, or omit it to leave scoping unchanged.
// The server validates the credentials against RevenueCat before persisting.
export const saveRevenueCatConfig = async (params: {
  communityId: string;
  projectId: string;
  secretApiKey?: string;
  currency?: string;
  appId?: string;
  appName?: string;
}): Promise<RevenueCatConfig> => {
  const callable = functions.httpsCallable("saveRevenueCatConfig");
  const result = await callable(params);
  return (result.data || {}) as RevenueCatConfig;
};

// List the project's apps so the admin can scope the community to one of them.
export const listRevenueCatApps = async (
  communityId: string
): Promise<RevenueCatApp[]> => {
  const callable = functions.httpsCallable("listRevenueCatApps");
  const result = await callable({ communityId });
  const { apps } = (result.data || {}) as { apps: RevenueCatApp[] };
  return apps ?? [];
};

// On-demand pull of overview metrics + a bounded sample of subscribers. Returns
// configured:false when the community has no RevenueCat credentials yet.
export const getRevenueCatSummary = async (
  communityId: string,
  limit?: number
): Promise<RevenueCatSummary> => {
  const callable = functions.httpsCallable("getRevenueCatSummary");
  const result = await callable({ communityId, limit });
  return (result.data || {}) as RevenueCatSummary;
};
